import React from 'react'
import './index.css'
import useSelector from 'hooks/use-selector'
import useDispatch from 'hooks/use-dispatch'
// import getMaxFreeSamplesCountCartSelect from 'modules/cart/redux/selectors/get-max-samples-count'
import ButtonLink from 'components/ButtonLink/index.js'
import openMiniCartSidebarGiftAction from 'modules/cart/redux/actions/open-mini-cart-sidebar'
import getItemsCountCartSelect from 'modules/cart/redux/selectors/get-items-count'
import getHashStringUtil from 'utils/string/get-hash'
import { CART_HASH_VALUE_ACTION } from 'modules/cart/constants'

export default function CartBottomBarViewCart () {
  const dispatch = useDispatch()
  const itemsCount = useSelector(getItemsCountCartSelect)

  const openMiniCart = (e) => {
    e.stopPropagation()
    dispatch(openMiniCartSidebarGiftAction())
  }

  return (
    <ButtonLink
      href={getHashStringUtil(CART_HASH_VALUE_ACTION.OPEN_MINI_CART_SIDEBAR)}
      onClick={openMiniCart}
      className='cart-bottom-bar-samples-count'
    >
      View cart ({itemsCount})
    </ButtonLink>
  )
}
